module.exports = __webpack_public_path__ + "static/media/develop.cd05cff7.svg";